import { Component } from '@theme/component';

/**
 * « Compléter le look » : liste des variantes d'un produit complémentaire.
 * Le <select> n'a pas de `name` ; à chaque changement, la variante choisie est
 * recopiée dans l'input caché `id` du formulaire Horizon
 * (<product-form-component>) et le prix affiché est mis à jour.
 * Tant qu'aucune taille n'est choisie (option vide en tête), le clic sur le
 * bouton et la soumission sont bloqués au niveau du formulaire, avant la
 * délégation d'événements d'Horizon, et un message s'affiche.
 *
 * @extends Component<{}>
 */
class MgLookSelect extends Component {
  requiredRefs = [];

  /** @type {AbortController | undefined} */
  #abortController;

  connectedCallback() {
    super.connectedCallback();

    const select = this.querySelector('select');
    if (!select) return;

    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    select.addEventListener('change', () => this.#sync(select), { signal });
    this.#sync(select);

    const form = this.closest('form');
    if (!form) return;
    form.addEventListener(
      'click',
      (event) => {
        const button = event.target instanceof Element ? event.target.closest('button[name="add"]') : null;
        if (!button || select.value !== '') return;
        event.preventDefault();
        event.stopPropagation();
        this.#showError(form);
      },
      { signal }
    );
    form.addEventListener(
      'submit',
      (event) => {
        if (select.value !== '') return;
        event.preventDefault();
        event.stopPropagation();
        this.#showError(form);
      },
      { signal }
    );
  }

  /** @param {HTMLFormElement} form */
  #showError(form) {
    const error = form.querySelector('.mg-look__error');
    if (error instanceof HTMLElement) error.hidden = false;
    this.classList.add('mg-look__select-wrapper--error');
    this.querySelector('select')?.focus();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController?.abort();
  }

  /**
   * @param {HTMLSelectElement} select
   */
  #sync(select) {
    const option = select.selectedOptions[0];
    if (!option) return;

    if (option.value !== '') {
      this.classList.remove('mg-look__select-wrapper--error');
      const error = this.closest('form')?.querySelector('.mg-look__error');
      if (error instanceof HTMLElement) error.hidden = true;
    }

    const form = this.closest('product-form-component');
    const variantIdInput = form?.querySelector('input[name="id"]');
    if (variantIdInput instanceof HTMLInputElement) variantIdInput.value = option.value;

    const price = this.closest('.mg-look__item')?.querySelector('[data-mg-look-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  }
}

if (!customElements.get('mg-look-select')) {
  customElements.define('mg-look-select', MgLookSelect);
}
